import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-left"
}
const _hoisted_2 = {
  key: 0,
  class: "border push-30 br-3 shadow-light bg-white position-abs z-999 push-10-t mh-300 overflow-y-scroll"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "font-w600" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("small", null, "Developer", -1 /* HOISTED */)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "font-w600" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "font-w600" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("small", null, "Account Owner", -1 /* HOISTED */)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.currentUser && _ctx.accessibleUsers && _ctx.accessibleUsers.length > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.open = !_ctx.open), ["prevent"]))
        }, [
          _createTextVNode(" Switch Account "),
          _createElementVNode("i", {
            class: _normalizeClass(["fa", { 'fa-chevron-down': !_ctx.open, 'fa-chevron-up': _ctx.open }])
          }, null, 2 /* CLASS */)
        ]),
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accessibleUsers, (u) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: _withModifiers(($event: any) => (_ctx.switchTo(u)), ["prevent"]),
                  class: _normalizeClass(["pad-20 hover-highlight", { 'hover-highlight-active': _ctx.isCurrent(u), 'hover-pointer': !_ctx.isCurrent(u) }]),
                  key: u.id
                }, [
                  (!!u.parentID)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(u.parent.accountName), 1 /* TEXT */),
                        _hoisted_6,
                        (u.roleTitle == _ctx.developerRole)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _hoisted_9))
                          : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                              _createElementVNode("small", null, "View as " + _toDisplayString(u.parent.fullName), 1 /* TEXT */)
                            ]))
                      ]))
                    : (!!u.advisorID)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, _toDisplayString(u.advisor.accountName), 1 /* TEXT */),
                          _hoisted_13,
                          _createElementVNode("span", null, [
                            _createElementVNode("small", null, _toDisplayString(u.advisor.fullName) + "'s Client", 1 /* TEXT */)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createElementVNode("span", _hoisted_15, _toDisplayString(u.accountName), 1 /* TEXT */),
                          _hoisted_16,
                          (u.accountOwner)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _hoisted_19))
                            : (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                _createElementVNode("small", null, _toDisplayString(u.roleTitle), 1 /* TEXT */)
                              ]))
                        ]))
                ], 10 /* CLASS, PROPS */, _hoisted_3))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}